import { differenceInMonths, parseISO } from 'date-fns';

// Maps the old relationship.status dropdown onto the two facts that replaced it.
// Every value implies cohabitation — the dropdown had no "never cohabited" option.
const LEGACY_STATUS_FACTS = {
	Married: { married: true, cohabited: true },
	'Cohabited for over two years': { married: false, cohabited: true },
	'Cohabited for under two years without children': {
		married: false,
		cohabited: true,
	},
	'Cohabited for under two years with Children': {
		married: false,
		cohabited: true,
	},
};

// undefined when there is nothing to derive: either the new questions are already
// answered, or the old status was never answered and must stay unanswered.
const legacyRelationshipFacts = (relationship = {}) => {
	const alreadyAnswered =
		relationship.married !== undefined || relationship.cohabited !== undefined;

	if (alreadyAnswered) {
		return undefined;
	}

	return LEGACY_STATUS_FACTS[relationship.status];
};

// Never stored: the agreement is rewritten on every autosave, so a persisted copy
// would go stale as soon as either date changed.
const cohabitationMonths = (relationship = {}) => {
	const { cohabitationDate, separationDate } = relationship;

	if (!cohabitationDate || !separationDate) {
		return 0;
	}

	const months = differenceInMonths(
		parseISO(separationDate),
		parseISO(cohabitationDate)
	);

	// Guards a separation date before the cohabitation date, and the NaN parseISO
	// yields for an unparseable string.
	return months > 0 ? months : 0;
};

// AB: Adult Interdependent Partner Agreement (AIRA s. 7). MB: registration under
// The Vital Statistics Act s. 13.1. NS: registered domestic partnership under the
// Vital Statistics Act s. 54(2)(g) — the only route to property for the unmarried.
const STATUS_AGREEMENT_PROVINCES = ['Alberta', 'Manitoba', 'Nova Scotia'];

const hasStatusAgreementRoute = (province) =>
	STATUS_AGREEMENT_PROVINCES.includes(province);

export {
	legacyRelationshipFacts,
	cohabitationMonths,
	STATUS_AGREEMENT_PROVINCES,
	hasStatusAgreementRoute,
};
